import { TransferListItem } from 'components/Form/TransferList'
import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { adUnitForTransferListFromDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST } from './api/query'
import { AdUnitForPageTransferListDTO, Data, Variables } from './api/types'
import { UseGetAdUnitsForPageTransferList, UseGetAdUnitsForPageTransferListProps } from './types'

export const useGetAdUnitsForPageTransferList = ({
  domainId,
}: UseGetAdUnitsForPageTransferListProps): UseGetAdUnitsForPageTransferList => {
  const ability = useAbility()

  const { data, isLoading: loading } = useQuery<Variables, Data, TransferListItem[]>({
    options: {
      enabled: !!domainId,
      select: (data: Data): TransferListItem[] =>
        data.node?.adUnits.map(
          (adUnit: AdUnitForPageTransferListDTO): TransferListItem =>
            adUnitForTransferListFromDTO(adUnit),
        ) ?? [],
    },
    query: GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST(ability),
    variables: { domainId },
  })

  const domainAdUnits: TransferListItem[] =
    data?.toSorted((a: TransferListItem, b: TransferListItem): number =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
    ) ?? []

  return {
    domainAdUnits,
    loading,
  }
}
